module.exports = __webpack_public_path__ + "img/stamp-golden-milestone-shot.3348a382.png";